import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  toNumber, toString, isEmpty, compact,
} from 'lodash';
import {
  Form,
  Button,
  Modal,
  Icon,
  Message,
  Select,
  Checkbox,
} from 'semantic-ui-react';
import Validator from 'validatorjs';
import { utcMoment } from '../../utilities/dateUtils';

import subscriptionProductTypeQuery from '../../graphql/subscriptionProductTypeQuery';
import client from '../../apollo';
import './subscriptionStyle.css';
import subscriptionCancellationReasons from '../../constants/subscriptionCancellationReasons';
import { MULTI_SUBSCRIPTION_ENABLED } from '../../config';
import {
  SA_PRODUCT_CODE,
  BUYER_SUBSCRIPTION_TYPE,
  SELLER_SUBSCRIPTION_TYPE,
} from '../../constants/subscriptions';

function getDateFormat() {
  return 'YYYY-MM-DD';
}

function validateStartDateField(field = 'startDate', value = undefined) {
  const startDate = value;
  if (isEmpty(startDate) && field === 'startDate') {
    return 'This field is required';
  }
  return '';
}

function validateEndDateField(field = 'endDate', value = undefined, startDate = undefined) {
  let endDate = value;
  const startD = moment(new Date(startDate)).format('YYYY-MM-DD');
  endDate = moment(new Date(endDate)).format('YYYY-MM-DD');
  if (
    moment(value).isValid() === false
    && endDate === 'Invalid date'
    && !isEmpty(value)
  ) {
    return 'Please input with a correct format value of YYYY-MM-DD';
  }
  if (isEmpty(endDate) && field === 'endDate') {
    return '';
  }
  if (
    !isEmpty(startD)
    && !isEmpty(endDate)
    && field === 'endDate'
    && moment(new Date(endDate)) <= moment(new Date(startD))
  ) {
    return 'End Date cannot be less than or equal to Start Date';
  }
  return '';
}

function subscriptionIsActive(startDate, endDate) {
  if (moment(startDate).isSameOrBefore(moment(new Date(), getDateFormat()))) {
    if (
      isEmpty(endDate)
      || (!isEmpty(endDate)
        && moment(endDate).isSameOrAfter(moment(new Date(), getDateFormat())))
    ) {
      return true;
    }
  }
  return false;
}

function startDateAllowedRange(field, subscription) {
  const { startDate, endDate } = subscription;
  const isActive = subscriptionIsActive(startDate, endDate);
  let date = null;
  if (field === 'min') {
    date = isActive
      ? moment(startDate, 'YYYY-MM-DD').subtract(7, 'days')
      : null;
  } else if (field === 'max') {
    date = isActive ? moment(new Date(startDate), 'YYYY-MM-DD') : null;
  }
  return date;
}

function isNonBundleProduct(prdName) {
  const productName = prdName.toLowerCase();
  return (
    productName === 'dealshield 21-day'
    || productName === 'dealshield 30-day'
    || productName === 'dealshield select 21-day'
    || productName === 'dealshield select 30-day'
  );
}

function renderDealerInfo(subscription) {
  if (isEmpty(subscription)) {
    return '';
  }
  if (isEmpty(subscription.dealerName)) {
    return `${subscription.dealerNumber}`;
  }
  return (
    !isEmpty(subscription)
    && `${subscription.dealerNumber} - ${subscription.dealerName}`
  );
}

class SubscriptionEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      subscriptionId: '',
      productId: '',
      productName: '',
      productCode: '',
      subscriptionType: '',
      priceDs: null,
      pricePsiLpi: null,
      networkPlusRate: null,
      notifyEmail: '',
      startDate: '',
      priceStartDate: '',
      endDate: '',
      dsPaidPsi: false,
      productTypes: [],
      confirmUpdating: false,
      errors: {},
      subscriptionCancellationReason: '',
    };
  }

  componentDidMount() {
    this.getProductTypesQuery();

    const { subscription } = this.props;

    const {
      id,
      subscription_id: subscriptionId,
      productId,
      productName,
      subscriptionType,
      priceDs,
      pricePsiLpi,
      networkPlusRate,
      notifyEmail,
      startDate,
      endDate,
      dsPaidPsi,
      subscriptionCancellationReason,
    } = subscription;

    this.setState({
      id: toNumber(id),
      subscriptionId,
      productId: toNumber(productId),
      productName: toString(productName),
      subscriptionType: toString(subscriptionType),
      priceDs,
      pricePsiLpi,
      networkPlusRate,
      notifyEmail: toString(notifyEmail),
      startDate,
      endDate: isEmpty(endDate) ? '' : utcMoment(moment(new Date(endDate))),
      priceStartDate: '',
      dsPaidPsi,
      subscriptionCancellationReason,
    });
  }

  onSelectHandler = field => (event, data) => {
    const selectedOption = data.options.find(o => o.value === data.value);
    const { key } = selectedOption;
    if (field === 'productName') {
      const selectedProductCode = selectedOption.productCode || '';
      this.setState({
        [field]: data.value,
        productId: key,
        productCode: selectedProductCode,
        ...(MULTI_SUBSCRIPTION_ENABLED && selectedProductCode === SA_PRODUCT_CODE && { dsPaidPsi: false }),
      });
    } else {
      this.setState({ [field]: data.value });
    }
  };

  onNumberChangeHandler = field => e => {
    const REGEX_NUMBER = /^[0-9\b]+$/i;

    if (REGEX_NUMBER.test(e.target.value) || isEmpty(e.target.value)) {
      this.setState({ [field]: e.target.value, errors: { [field]: '' } });
      return true;
    }
    this.setState({
      [field]: e.target.value,
      errors: { [field]: 'Invalid format number' },
    });
    return false;
  };

  onEmailChangeHandler = field => event => {
    const REGEX_MULTIPLE_EMAILS = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})((,| ,|, | , |;| ;|; | ; |){1}[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/i;

    if (
      REGEX_MULTIPLE_EMAILS.test(event.target.value)
      || isEmpty(event.target.value)
    ) {
      this.setState({ [field]: event.target.value, errors: { [field]: '' } });
      return true;
    }
    this.setState({
      [field]: event.target.value,
      errors: {
        [field]:
            'Invalid email format. If using multi email e.g. user1@gmail.com,user2@gmail.com,...',
      },
    });
    return false;
  };

  ValidatePriceStartDate = subscription => {
    const {
      startDate,
      endDate,
      priceStartDate,
      priceDs,
      pricePsiLpi,
      networkPlusRate,
    } = this.state;
    const startD = moment(new Date(startDate), getDateFormat());
    const endD = moment(new Date(endDate), getDateFormat());
    const priceStartD = moment(new Date(priceStartDate), getDateFormat());

    if (!isEmpty(priceStartDate) && priceStartD.isValid() === false) {
      this.setState({
        errors: {
          priceStartDate:
            'Please input with a correct format value of YYYY-MM-DD',
        },
      });
      return true;
    }

    if (priceStartD.isBefore(startD)) {
      this.setState({
        errors: {
          priceStartDate: 'Selected Price Date is less than subscription',
        },
      });
      return true;
    }

    if (!isEmpty(endDate) && priceStartD.isAfter(endD)) {
      this.setState({
        errors: {
          priceStartDate:
            'Selected Price Date is greater than subscription end date',
        },
      });
      return true;
    }

    if (
      isEmpty(priceStartDate)
      && (priceDs !== subscription.priceDs
        || pricePsiLpi !== subscription.pricePsiLpi
        || parseInt(networkPlusRate, 10) !== subscription.networkPlusRate)
    ) {
      this.setState({
        errors: {
          priceStartDate: 'Required',
        },
      });
      return true;
    }

    return false;
  };

  showMsgValidationDate = (field, value) => {
    let msg = '';
    const { startDate } = this.state;

    if (field === 'startDate') {
      msg = validateStartDateField(field, value);
    }

    if (field === 'endDate') {
      msg = validateEndDateField(field, value, startDate);
    }

    return msg;
  };

  onDateChangeHandler = field => date => {
    if (
      field === 'startDate'
      || field === 'endDate'
      || field === 'priceStartDate'
    ) {
      this.setState({
        [field]:
          !isEmpty(date)
          && moment(date).isValid()
          && moment(new Date(date._d)).format('YYYY-MM-DD'),
        errors: {
          [field]: '',
        },
      });
    }
    if (field === 'endDate' && isEmpty(date)) {
      this.setState({ subscriptionCancellationReason: '' });
    }
  };

  onDateFocusHandler = field => event => {
    if (!event) return;
    const val = event.target.value;

    const { endDate } = this.state;

    if (
      field === 'startDate'
      && moment(new Date(val)) >= moment(new Date(endDate))
    ) {
      this.setState({
        startDate: val,
        endDate: '',
        errors: {
          startDate: '',
        },
      });
      return;
    }

    const msg = this.showMsgValidationDate(field, val);

    this.setState({
      [field]: val,
      errors: {
        [field]: msg,
      },
    });
  };

  getProductTypesQuery = () => {
    const { subscription } = this.props;
    client
      .query({
        query: subscriptionProductTypeQuery,
      })
      .then(({ data }) => {
        const { subscriptionProductType: allProductTypes } = data;
        let productTypes = allProductTypes;
        if (MULTI_SUBSCRIPTION_ENABLED) {
          const { subscriptionType } = subscription;
          const isSeller = subscriptionType === SELLER_SUBSCRIPTION_TYPE;
          const isBuyer = subscriptionType === BUYER_SUBSCRIPTION_TYPE;
          productTypes = allProductTypes.filter(pt => {
            if (isSeller && pt.productCode !== SA_PRODUCT_CODE) return false;
            if (isBuyer && pt.productCode === SA_PRODUCT_CODE) return false;
            return true;
          });
        }
        const { productName } = this.state;
        const selected = productTypes.find(o => o.value === productName);
        this.setState({
          productTypes,
          productCode: selected ? selected.productCode : '',
        });
      })
      .catch(() => {
        this.setState({ productTypes: [] });
      });
  };

  validateStartDate = (selectedDate, subscription) => {
    const startDateAllowedRangeMin = startDateAllowedRange(
      'min',
      subscription
    );
    const startDateAllowedRangeMax = startDateAllowedRange(
      'max',
      subscription
    );

    if (moment(selectedDate).isBefore(startDateAllowedRangeMin)) {
      this.setState({
        errors: {
          startDate: 'Selected Date not allow for an active subscription',
        },
      });
      return true;
    } if (
      startDateAllowedRangeMax.isValid()
      && moment(selectedDate).isAfter(startDateAllowedRangeMax)
    ) {
      this.setState({
        errors: {
          startDate: 'Selected Date not allow for an active subscription',
        },
      });
      return true;
    }
    return false;
  };

  validationRules = {
    priceDs: 'required|numeric',
    productName: 'required|string',
    pricePsiLpi: 'numeric',
    notifyEmail: 'required',
    startDate: 'required',
  };

  getBundlePricePsiLpi = prodName => {
    const { pricePsiLpi } = this.state;
    return isNonBundleProduct(prodName) ? '' : pricePsiLpi;
  };

  onSubmitForm = () => {
    const { subscription, onSubmitHandler, subscriptions } = this.props;
    const { active, dealerName, dealerNumber } = subscription;
    const {
      id,
      subscriptionId,
      productId,
      productName,
      subscriptionType,
      priceDs,
      pricePsiLpi,
      networkPlusRate,
      notifyEmail,
      priceStartDate,
      startDate,
      endDate,
      dsPaidPsi,
      subscriptionCancellationReason,
    } = this.state;

    const formattedNetworkPlusRate = isEmpty(`${networkPlusRate}`)
      ? 0
      : parseInt(networkPlusRate, 10);
    const formattedStartDate = moment(new Date(startDate)).isValid()
      ? moment(new Date(startDate)).format('YYYY-MM-DD')
      : 'Invalid Date';

    let formattedEndDate;
    if (isEmpty(endDate)) {
      formattedEndDate = '';
    } else {
      const parsedEndDate = moment(new Date(endDate));
      formattedEndDate = parsedEndDate.isValid()
        ? parsedEndDate.format('YYYY-MM-DD')
        : 'Invalid Date';
    }

    let formattedPriceStartDate;
    if (isEmpty(priceStartDate)) {
      formattedPriceStartDate = '';
    } else {
      const parsedPriceStartDate = moment(new Date(priceStartDate));
      formattedPriceStartDate = parsedPriceStartDate.isValid()
        ? parsedPriceStartDate.format('YYYY-MM-DD')
        : 'Invalid Date';
    }

    if (formattedStartDate === 'Invalid Date' && !isEmpty(startDate)) {
      this.setState({
        errors: {
          startDate: 'Please input with a correct format value of YYYY-MM-DD',
        },
      });
      return false;
    }

    if (formattedEndDate === 'Invalid Date' && !isEmpty(endDate)) {
      this.setState({
        errors: {
          endDate: 'Please input with a correct format value of YYYY-MM-DD',
        },
      });
      return false;
    }

    // US1565278-Update DS price UI validation
    const isValidDsPrice = price => {
      const sameDsPrice = price === subscription.priceDs;
      const inRange = price === 0 || (price >= 1 && price <= 999);
      return inRange || sameDsPrice;
    };

    if (!isValidDsPrice(parseFloat(priceDs))) {
      this.setState({
        errors: {
          priceDs:
            'Please input with a correct Dealshield price (0 or from 1 to 999)',
        },
      });
      return false;
    }

    if (
      !isEmpty(`${pricePsiLpi}`)
      && parseFloat(pricePsiLpi) !== 0
      && parseFloat(pricePsiLpi) < 1
    ) {
      this.setState({
        errors: {
          pricePsiLpi:
            'Please input with a correct PSI/LPI price (0 or from 1 to 999)',
        },
      });
      return false;
    }

    const REGEX_MULTIPLE_EMAILS = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})((,| ,|, | , |;| ;|; | ; |){1}[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/i;
    const REGEX_EMAIL_SEPARATES = /(?:,)|(?:;)|(\s)/g;
    const formatNotifyEmail = compact(
      notifyEmail.split(REGEX_EMAIL_SEPARATES)
    )
      .map(email => email.replaceAll(' ', ''))
      .filter(Boolean)
      .join(',');

    const validation = new Validator(this.state, this.validationRules, {
      'required.productName': 'This field is required',
      'required.priceDs': 'This field is required',
      'required.notifyEmail': 'This field is required',
      'required.startDate': 'This field is required',
    });

    if (
      !isEmpty(formattedStartDate)
      && !isEmpty(formattedEndDate)
      && moment(new Date(formattedEndDate)) <= moment(new Date(formattedStartDate))
    ) {
      this.setState({
        endDate: moment(new Date(formattedEndDate)).format('YYYY-MM-DD'),
        errors: {
          endDate: 'End Date cannot be less than or equal to Start Date',
        },
      });
      return false;
    }

    if (!isEmpty(formattedEndDate) && isEmpty(subscriptionCancellationReason)) {
      this.setState({
        errors: {
          subscriptionCancellationReason: 'Cancellation Reason is required',
        },
      });
      return false;
    }

    if (validation.fails()) {
      this.setState({ ...validation.errors });
      return false;
    }

    if (!REGEX_MULTIPLE_EMAILS.test(notifyEmail)) {
      this.setState({
        errors: {
          notifyEmail:
            'Invalid email format. If using multi email e.g. user1@gmail.com,user2@gmail.com,...',
        },
      });
      return false;
    }

    if (this.ValidatePriceStartDate(subscription)) {
      return false;
    }

    if (this.validateStartDate(formattedStartDate, subscriptions)) {
      return false;
    }

    const finalPricePsiLpi = isNonBundleProduct(productName) ? 0 : pricePsiLpi;

    onSubmitHandler({
      id: parseInt(id, 10),
      subscription_id: parseInt(subscriptionId, 10),
      dealerName,
      dealerNumber: parseInt(dealerNumber, 10),
      productId: parseInt(productId, 10),
      productName,
      subscriptionType: subscriptionType || 'BUYER',
      priceDs: parseFloat(priceDs),
      pricePsiLpi: parseFloat(finalPricePsiLpi),
      networkPlusRate: parseInt(formattedNetworkPlusRate, 10),
      notifyEmail: formatNotifyEmail || '',
      active,
      priceStartDate: formattedPriceStartDate || '',
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      dsPaidPsi,
      subscriptionCancellationReason,
    });
    return true;
  };

  onConfirmUpdate = () => {
    this.setState({ confirmUpdating: true });
  };

  handleCheckboxChange = field => (event, data) => {
    event.preventDefault();

    this.setState({ [field]: data.checked });
  };

  render() {
    const {
      productId,
      productName,
      productCode,
      subscriptionType,
      priceDs,
      networkPlusRate,
      notifyEmail,
      errors,
      productTypes,
      priceStartDate,
      startDate,
      endDate,
      dsPaidPsi,
      confirmUpdating,
      subscriptionCancellationReason,
    } = this.state;

    const {
      isModalOpen,
      onCloseHandler,
      error,
      submitting,
      subscription,
    } = this.props;

    const headerStyle = {
      display: 'grid',
      justifyContent: 'space-between',
      gridTemplateColumns: 'auto auto',
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
        data-testid='edit-subscription-modal'
      >
        <Modal.Header style={headerStyle}>
          <span>Edit DealShield Subscription</span>
          <span>{renderDealerInfo(subscription)}</span>
        </Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}

            <Form>
              <Form.Group>
                <Form.Field width={8} required error={!isEmpty(errors.productName)}>
                  <label htmlFor='productName'>DealShield Product Selection</label>
                  <Select
                    id='productName'
                    data-testid='product-dropdown'
                    placeholder='Select DealShield Product'
                    options={productTypes}
                    closeOnBlur
                    key={productId}
                    value={productName}
                    onChange={this.onSelectHandler('productName')}
                  />
                  {errors.productName && (
                    <div style={{ color: 'red' }}>{errors.productName}</div>
                  )}
                </Form.Field>
                <Form.Field style={{ width: '25%' }}>
                  <label htmlFor='subscriptionType'>Subscription Type</label>
                  <input
                    id='subscriptionType'
                    name='subscriptionType'
                    value={subscriptionType ? subscriptionType.charAt(0).toUpperCase() + subscriptionType.slice(1).toLowerCase() : ''}
                    type='text'
                    readOnly
                    className='disabled-input'
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.priceDs)}>
                  <label htmlFor='priceDs'>DealShield Price</label>
                  <input
                    id='priceDs'
                    name='priceDs'
                    value={priceDs}
                    defaultValue={priceDs}
                    onChange={this.onNumberChangeHandler('priceDs')}
                    placeholder='N/A'
                    type='text'
                    pattern='\d*'
                    maxLength='3'
                  />
                  {errors.priceDs && (
                    <div style={{ color: 'red' }}>{errors.priceDs}</div>
                  )}
                </Form.Field>

                <Form.Field error={!isEmpty(errors.networkPlusRate)}>
                  <label htmlFor='networkPlusRate'>Network Plus Adjustment</label>
                  <input
                    id='networkPlusRate'
                    name='networkPlusRate'
                    value={networkPlusRate}
                    defaultValue={networkPlusRate}
                    onChange={this.onNumberChangeHandler('networkPlusRate')}
                    placeholder='N/A'
                    type='text'
                    pattern='\d*'
                    maxLength='4'
                  />
                  {errors.networkPlusRate && (
                    <div style={{ color: 'red' }}>{errors.networkPlusRate}</div>
                  )}
                </Form.Field>

                <Form.Field error={!isEmpty(errors.pricePsiLpi)}>
                  <label htmlFor='pricePsiLpi'>DealShield PSI / LPI Price</label>
                  <input
                    id='pricePsiLpi'
                    name='pricePsiLpi'
                    value={this.getBundlePricePsiLpi(productName)}
                    onChange={this.onNumberChangeHandler('pricePsiLpi')}
                    placeholder='N/A'
                    type='text'
                    pattern='\d*'
                    maxLength='3'
                    disabled={isNonBundleProduct(productName)}
                  />
                  {errors.pricePsiLpi && (
                    <div style={{ color: 'red' }}>{errors.pricePsiLpi}</div>
                  )}
                </Form.Field>

                <Form.Field error={!isEmpty(errors.priceStartDate)}>
                  <label htmlFor='priceStartDate'>Price Start Date</label>
                  <DatePicker
                    id='priceStartDate'
                    key='priceStartDate'
                    style={{ padding: '0', width: '100%' }}
                    selected={
                      !isEmpty(priceStartDate)
                      && moment(priceStartDate).isValid()
                        ? moment(priceStartDate)
                        : null
                    }
                    placeholderText='Select price start date'
                    minDate={moment(new Date(), 'YYYY-MM-DD')}
                    maxDate={moment(new Date(), 'YYYY-MM-DD').add('30', 'days')}
                    onChange={this.onDateChangeHandler('priceStartDate')}
                    onBlur={this.onDateFocusHandler('priceStartDate')}
                    dateFormat='YYYY/MM/DD'
                    maxLength='10'
                    popperPlacement='bottom-start'
                    popperProps={{ positionFixed: true }}
                  />
                  {errors.priceStartDate && (
                    <div style={{ color: 'red' }}>{errors.priceStartDate}</div>
                  )}
                </Form.Field>
              </Form.Group>

              <Form.Group>
                <Form.Field
                  style={{ width: '50%' }}
                  required
                  error={!isEmpty(errors.notifyEmail)}
                >
                  <label htmlFor='notifyEmail'>POC Email Address</label>
                  <input
                    id='notifyEmail'
                    name='notifyEmail'
                    placeholder='Please input email'
                    value={notifyEmail}
                    onChange={this.onEmailChangeHandler('notifyEmail')}
                  />
                  {errors.notifyEmail && (
                    <div style={{ color: 'red' }}>{errors.notifyEmail}</div>
                  )}
                </Form.Field>
              </Form.Group>

              <Form.Group style={{ flexWrap: 'nowrap' }}>
                <Form.Field required error={!isEmpty(errors.startDate)}>
                  <label htmlFor='startDate'>Subscription Start Date</label>
                  <DatePicker
                    id='startDate'
                    key='startDate'
                    style={{ padding: '0', width: '100%' }}
                    selected={
                      !isEmpty(startDate) && moment(startDate).isValid()
                        ? moment(startDate)
                        : null
                    }
                    minDate={startDateAllowedRange('min', subscription)}
                    maxDate={startDateAllowedRange('max', subscription)}
                    onChange={this.onDateChangeHandler('startDate')}
                    onBlur={this.onDateFocusHandler('startDate')}
                    dateFormat='YYYY/MM/DD'
                    maxLength='10'
                    popperPlacement='bottom-start'
                    popperProps={{ positionFixed: true }}
                  />
                  {errors.startDate && (
                    <div style={{ color: 'red' }}>{errors.startDate}</div>
                  )}
                </Form.Field>

                <Form.Field error={!isEmpty(errors.endDate)}>
                  <label htmlFor='endDate'>Subscription End Date</label>
                  <DatePicker
                    id='endDate'
                    style={{ padding: '0', width: '100%' }}
                    selected={
                      !isEmpty(endDate) && moment(endDate).isValid()
                        ? moment(endDate)
                        : null
                    }
                    minDate={moment(new Date(startDate), 'YYYY-MM-DD ZZ')}
                    onChange={this.onDateChangeHandler('endDate')}
                    onBlur={this.onDateFocusHandler('endDate')}
                    dateFormat='YYYY/MM/DD'
                    maxLength='10'
                    popperPlacement='bottom-start'
                    popperProps={{ positionFixed: true }}
                  />
                  {errors.endDate && (
                    <div style={{ color: 'red' }}>{errors.endDate}</div>
                  )}
                </Form.Field>
                {(!MULTI_SUBSCRIPTION_ENABLED || productCode !== SA_PRODUCT_CODE) && (
                  <Form.Field data-testid='edit-ds-paid-psi-field'>
                    <label htmlFor='dsPaidPsi' style={{ whiteSpace: 'nowrap' }}>DS Paid PSI</label>
                    <Checkbox
                      id='dsPaidPsi'
                      checked={dsPaidPsi}
                      onChange={this.handleCheckboxChange('dsPaidPsi')}
                    />
                  </Form.Field>
                )}
                <Form.Field
                  required
                  error={!isEmpty(errors.subscriptionCancellationReason)}
                  style={{ width: '50%' }}
                >
                  <label htmlFor='subscriptionCancellationReason'>Reason</label>
                  <Select
                    id='subscriptionCancellationReason'
                    placeholder='Select cancellation reason'
                    options={
                      subscriptionCancellationReasons.CANCELLATION_REASONS
                    }
                    closeOnBlur
                    value={
                      isEmpty(endDate) ? '' : subscriptionCancellationReason
                    }
                    onChange={this.onSelectHandler(
                      'subscriptionCancellationReason'
                    )}
                    disabled={isEmpty(endDate)}
                  />
                  {errors.subscriptionCancellationReason && (
                    <div style={{ color: 'red' }}>
                      {errors.subscriptionCancellationReason}
                    </div>
                  )}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting && !confirmUpdating && (
            <Button color='green' onClick={this.onConfirmUpdate} inverted>
              <Icon name='checkmark' /> Update
            </Button>
          )}
          {confirmUpdating && !submitting && (
            <Button color='green' onClick={this.onSubmitForm} inverted>
              <Icon name='checkmark' /> Are You Sure?
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

SubscriptionEdit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  subscription: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subscription_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dealerName: PropTypes.string,
    dealerNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    productName: PropTypes.string,
    subscriptionType: PropTypes.string,
    priceDs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pricePsiLpi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    networkPlusRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    notifyEmail: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    dsPaidPsi: PropTypes.bool,
    subscriptionCancellationReason: PropTypes.string,
    active: PropTypes.bool,
  }),
  subscriptions: PropTypes.arrayOf(PropTypes.object),
};

SubscriptionEdit.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
  subscription: {},
  subscriptions: [],
};

export default SubscriptionEdit;
